import { FC, ReactNode } from 'react';
import { HiXMark } from 'react-icons/hi2';

interface AttachBulkBarProps {
    count: number;
    onClear: () => void;
    /** Всего файлов в выборке (все страницы) — для «Выбрать все N». */
    total: number;
    /** Выбрать все файлы; без него (выбраны все или выбор всех запрещён) кнопки нет. */
    onSelectAll?: () => void;
    /** Чипы групповых действий (строятся снаружи из fetchGroupActions). */
    children?: ReactNode;
}

/** Панель групповых действий — появляется при выделении строк. */
const AttachBulkBar: FC<AttachBulkBarProps> = ({ count, onClear, total, onSelectAll, children }) => {
    if (count === 0) return null;
    return (
        <div className="atb__bulk is-visible">
            <span className="atb__bulk-count">
                <b>{count}</b> выбрано
            </span>
            {onSelectAll && (
                <button type="button" className="atb__chip atb__chip--ghost" onClick={onSelectAll}>
                    Выбрать все {total}
                </button>
            )}
            <div className="atb__bulk-actions">{children}</div>
            <div className="atb__bulk-spacer" />
            <button type="button" className="atb__chip atb__chip--ghost" onClick={onClear}>
                <HiXMark aria-hidden />
                Снять выделение
            </button>
        </div>
    );
};

export default AttachBulkBar;
